var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplayRtl = function SvgReplayRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.003 22.497a2.695 2.695 0 0 0 2.674 2.356h.361l8.402-1.106C2.711 42.691 6.08 70.025 24.965 84.8S71.1 96.194 85.828 77.251s11.36-46.277-7.525-61.052A43.28 43.28 0 0 0 51.589 7a2.715 2.715 0 0 0-2.71 2.719 2.715 2.715 0 0 0 2.71 2.719c20.956-.009 37.95 17.025 37.96 38.046.008 21.02-16.973 38.068-37.929 38.077-20.955.008-37.95-17.026-37.958-38.047a38.14 38.14 0 0 1 8.476-23.994l.452 10.513a2.714 2.714 0 0 0 2.692 2.591h.126a2.68 2.68 0 0 0 2.584-2.827l-.723-16.874a.3.3 0 0 0 0-.127q.015-.135 0-.272v-.38a.25.25 0 0 0 0-.11 3 3 0 0 0-.162-.325 2.6 2.6 0 0 0-.813-.834 2.6 2.6 0 0 0-.38-.218l-.36-.127h-1.067L8.605 19.652a2.715 2.715 0 0 0-2.602 2.846",
    clipRule: "evenodd"
  })));
};
export default SvgReplayRtl;